var render = function (_h,_vm) {var _c=_vm._c;return _c('p',{ref:_vm.data.ref,staticClass:"text-red-500 text-xs italic has-error"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }